import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Channel'),"outlined":"","hide-details":"auto","items":_vm.channels,"item-text":"text","item-value":"value"},model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }